export default __webpack_public_path__ + "static/media/Snowing_02.76664135.png";